<template>
  <div class="row my-modal" v-if="visible" v-on:keyup.esc="close">
    <div class="col-12">
      <h3 v-if="!update_mode && !running">Criar Nota</h3>
      <h3 v-if="!update_mode && running">Criando Nota</h3>
      <h3 v-if="update_mode && !running">Atualizar Nota</h3>
      <h3 v-if="update_mode && running">Atualizando Nota</h3>
      <form v-on:submit.prevent="createNote">
        <button v-if="!update_mode" type="submit" class="btn btn-primary">Criar</button>
        <button v-if="!update_mode" v-on:click.prevent="close" class="btn btn-light">Fechar</button>
        <button v-if="update_mode" type="submit" class="btn btn-primary">Atualizar</button>
        <button v-if="update_mode" v-on:click.prevent="close" class="btn btn-light">Fechar</button>
        <div class="form-group">
          <label for="inputTitle">Título</label>
          <input type="text" class="form-control" id="inputTitle" v-model="title" ref="title">
        </div>
        <div class="form-group" v-if="raw_mode">
          <label for="inputContent">Nota</label><a href="#" v-on:click.prevent="viewNormalMode" class="view-mode">(View normal mode)</a>
          <textarea rows="20" class="form-control fixed-font" id="inputContent" v-model="content"></textarea>
        </div>
        <div class="form-group" v-else="raw_mode">
          <label for="inputContent">Nota</label><a href="#" v-on:click.prevent="viewRawMode" class="view-mode">(View raw mode)</a>
          <span v-for="(line, lineNumber) in this.lines">
            <NotesFormLine v-if="line.type === 'text'" v-bind:position="lineNumber" v-bind:value="line.value" v-on:line-changed="lineChanged" />
            <NotesFormLine v-if="line.type !== 'text'" v-bind:position="lineNumber" v-bind:value="JSON.stringify(line)" v-on:line-changed="lineChanged" />
          </span>
        </div>
        <div v-if="showConfirmationDialog">
          <button v-on:click.prevent="closeConfirmationDialog" class="btn btn-light">Cancelar</button>
          <button v-on:click.prevent="deleteCurrentNote" class="btn btn-danger" style="margin-left: 80px;">Realmente Excluir</button>
        </div>
        <div v-if="!showConfirmationDialog">
          <button v-if="!update_mode" type="submit" class="btn btn-primary">Criar</button>
          <button v-if="!update_mode" v-on:click.prevent="close" class="btn btn-light">Fechar</button>
          <button v-if="update_mode" type="submit" class="btn btn-primary">Atualizar</button>
          <button v-if="update_mode" v-on:click.prevent="confirmCurrentNoteDeletion" class="btn btn-danger">Excluir</button>
          <button v-if="update_mode" v-on:click.prevent="close" class="btn btn-light">Fechar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import NotesFormLine from './NotesFormLine'
import NoteParser from '../shared/NoteParser'

export default {
  name: 'NotesForm',
  props: {
    note: Object,
    visible: Boolean
  },
  components: { NotesFormLine },
  data: () => {
    return {
      title: '',
      content: '',
      lines: [],
      id: null,
      raw_mode: false,
      update_mode: false,
      show_confirmation_dialog: false,
      is_running: false
    }
  },
  computed: {
    running() {
      return this.is_running
    },
    showConfirmationDialog() {
      return this.show_confirmation_dialog ? true : false
    }
  },
  watch: {
    note (newNote, oldNote) {
      if (newNote) {
        this.id      = newNote.id
        this.title   = newNote.title
        this.content = newNote.content
        this.lines   = NoteParser.parse(this.content)
        this.update_mode = true
      } else {
        this.id      = null
        this.title   = ''
        this.content = ''
        this.lines   = []
        this.update_mode = false
      }
    },
    visible (newVal, oldVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          // this.$refs.title.focus()
        })
      }
    }
  },
  methods: {
    createNote: function() {
      let createSuccess = (response) => {
        this.is_running = false
        if (response.body.data) {
          this.id = response.body.data.id
          this.$emit('note-created', { id: this.id, title: this.title, content: this.content })
          this.update_mode = true
        }
      }

      let createError = (response) => {
        debugger
      }

      let updateSuccess = (response) => {
        this.is_running = false
        this.$emit('note-updated', { id: this.id, title: this.title, content: this.content })
      }

      let updateError = (response) => {
        debugger
      }

      this.is_running = true
      if (this.update_mode) {
        this.$http.put(`${this.$root.base_url}/notes/${this.id}`, { title: this.title, content: this.content }, { headers: { Token: this.$cookies.get('api_token') } }).then(updateSuccess, updateError)
      } else {
        this.$http.post(`${this.$root.base_url}/notes/create`, { title: this.title, content: this.content }, { headers: { Token: this.$cookies.get('api_token') } }).then(createSuccess, createError)
      }
    },
    confirmCurrentNoteDeletion: function() {
      if (this.update_mode) {
        this.show_confirmation_dialog = true
      }
    },
    closeConfirmationDialog() {
      this.show_confirmation_dialog = false
    },
    deleteCurrentNote: function() {
      if (this.update_mode) {
        this.show_confirmation_dialog = false
        let deleteSuccess = (response) => {
          this.$emit('note-deleted', this.id)
          // this.id      = null
          // this.title   = ''
          // this.content = ''
          // this.update_mode = false
        }

        let deleteError = (response) => {
          debugger
        }

        this.$http.delete(`${this.$root.base_url}/notes/${this.id}`, { headers: { Token: this.$cookies.get('api_token') } }).then(deleteSuccess, deleteError)
      }
    },
    viewRawMode: function() {
      this.raw_mode = true
    },
    viewNormalMode: function() {
      this.raw_mode = false
    },
    close: function() {
      this.$emit('form-close')
    },
    unSelect: function() {
      this.id      = null
      this.title   = ''
      this.content = ''
      this.update_mode = false
      this.$emit('note-unselected')
    },
    lineChanged: function(value, position) {
      console.log(`Value: ${value}`)
      console.log(`Position: ${position}`)
      return null
    }
  },
  mounted(){
    if (this.note) {
      this.id      = this.note.id
      this.title   = this.note.title
      this.content = this.note.content
      this.update_mode = true
    }
  }
}
</script>

<style>
.my-modal {
  position: absolute;
  top: 0px;
  left: 14px;
  right: 20px;
  bottom: 20px;
  height: 600px;
  background-color: #323273;
}
a.view-mode {
  margin-left: 20px;
}
a.view-mode:visited {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/NotesForm.vue